import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { useIssues } from "@/lib/useIssues";
import { AlertTriangle, ArrowRight } from "lucide-react";

export function IssuesBanner() {
    const { data } = useIssues();
    const n = data?.count || 0;
    if (!n) return null;
    return (
        <Card className="p-3 border-l-4 border-l-loss bg-loss/5 flex items-center justify-between gap-3 flex-wrap" data-testid="issues-banner">
            <div className="flex items-center gap-2.5 text-sm">
                <AlertTriangle className="w-4 h-4 text-loss shrink-0" />
                <span><b>{n} open issue{n > 1 ? "s" : ""}</b> may be affecting these holdings (wrong sub-portfolio, leftover shares, ticker changes…).</span>
            </div>
            <Link to="/issues" className="text-sm text-primary font-medium inline-flex items-center gap-1 hover:underline" data-testid="issues-banner-link">
                Review <ArrowRight className="w-3.5 h-3.5" />
            </Link>
        </Card>
    );
}
